export const styles = {
  wrapper: {
    '& td:last-child, th:last-child': {
      paddingRight: '35px',
    },
    '& td:first-child, th:first-child': {
      paddingLeft: '35px',
    },
    '& .link-edit-main': {
      right: '40px',
    },
  },
  wrapperTable: {
    width: '100%',
  },
  filtersContainer: {
    content: props => props.path,
    marginRight: 65,
    marginTop: 30,
  },
  loadingAllWrapper: {
    height: ' calc(100vh - 133px)',
  },
  loadingTableWrapper: {
    height: 'calc(100vh - 427px)',
  },
  spyColumn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  deleteIconWrapper: {
    cursor: 'pointer',
    marginLeft: 10,
    marginTop: 4,
  },
  link: {
    fontSize: 14,
    color: '#000000',
    cursor: 'pointer',
  },
  exportButton: {
    position: 'absolute',
    right: 90,
    '& .isLoading': {
      marginLeft: 10,
    },
  },
}
